<template>
  <div class="toolbar-item">
    <span class="demonstration">承运公司</span>
    <el-select
      v-model="carrierCompanyCode"
      placeholder="请选择"
      clearable
      @change="changeSelect"
      @clear="clear"
      class="normal"
      style="width: 226px"
    >
      <el-option
        v-for="(item, idx) in carrierCompanyList"
        :label="item.carrierCompanyName"
        :value="item.carrierCompanyCode"
        :key="idx"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import api from '@/api/base.new.api';
import axios from '@/api/axiosNew';
export default {
  name: 'CarrierCompany',
  data() {
    return {
      carrierCompanyCode: '',
      carrierCompanyList: []
    };
  },
  created() {
    axios.post(api.companyTaxQueryList).then(res => {
      this.carrierCompanyList = res.data;
    });
  },
  methods: {
    changeSelect(val) {
      this.$emit('changeValue', val);
    },
    clear() {
      this.$emit('changeValue', '');
    }
  }
};
</script>
